import { QuestionType } from './question-type.enum';

/**
 * Utility to map API type strings to QuestionType enum values
 */
export class QuestionTypeMapper {
  /**
   * Map API type string to QuestionType enum
   */
  static mapApiTypeToQuestionType(apiType: string): QuestionType | null {
    const typeMap: Record<string, QuestionType> = {
      // Direct mappings (case-insensitive matching will be done via normalizedType)
      'title': QuestionType.Title,
      'section': QuestionType.Section,
      'input': QuestionType.TextBox,
      'inputbox': QuestionType.TextBox,
      'textbox': QuestionType.TextBox,
      'input-box': QuestionType.TextBox,
      'checkbox': QuestionType.CheckboxList,
      'checkboxlist': QuestionType.CheckboxList,
      'checkbox-list': QuestionType.CheckboxList,
      'dropdown': QuestionType.DropdownList,
      'dropdownlist': QuestionType.DropdownList,
      'dropdown-list': QuestionType.DropdownList,
      'dynamicdropdown': QuestionType.DynamicDropdown,
      'dynamic-dropdown': QuestionType.DynamicDropdown,
      'dynamicdropdownlist': QuestionType.DynamicDropdown,
      'email': QuestionType.Email,
      'date': QuestionType.Date,
      'tel': QuestionType.Tel,
      'phone': QuestionType.Tel,
      'phonenumber': QuestionType.Tel,
      'phone-number': QuestionType.Tel,
      'radio': QuestionType.Radio,
      'radiolist': QuestionType.Radio,
      'radio-list': QuestionType.Radio,
      'textarea': QuestionType.TextArea,
      'text-area': QuestionType.TextArea,
      'toggle': QuestionType.Toggle,
      'confirmation': QuestionType.Confirmation,
      'confirm': QuestionType.Confirmation,
      'declaration': QuestionType.Confirmation,
      'helpertext': QuestionType.HelperText
    };

    // Normalize: trim whitespace and convert to lowercase for case-insensitive matching
    const normalizedType = apiType.trim().toLowerCase();
    return typeMap[normalizedType] || null;
  }

  /**
   * Map QuestionType enum to API type string
   */
  static mapQuestionTypeToApiType(questionType: QuestionType): string {
    const reverseMap: Record<QuestionType, string> = {
      [QuestionType.TextBox]: 'Input',
      [QuestionType.CheckboxList]: 'Checkbox',
      [QuestionType.DropdownList]: 'Dropdown',
      [QuestionType.DynamicDropdown]: 'DynamicDropdown',
      [QuestionType.Email]: 'Email',
      [QuestionType.Date]: 'Date',
      [QuestionType.Tel]: 'Tel',
      [QuestionType.Radio]: 'Radio',
      [QuestionType.TextArea]: 'TextArea',
      [QuestionType.Toggle]: 'Toggle',
      [QuestionType.Confirmation]: 'Confirmation',
      [QuestionType.HelperText]: 'HelperText',
      [QuestionType.Section]: 'Section',
      [QuestionType.Title]: 'Title'
    };

    return reverseMap[questionType] || questionType;
  }
}

